import { useEffect, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { heroData } from '../mock';

export const Hero = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end start']
  });

  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [1, 0.8, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.2]);

  const titleVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.3
      }
    }
  };

  const lineVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.6, 0.05, 0.01, 0.9]
      }
    }
  };

  return (
    <div ref={containerRef} className="relative h-screen overflow-hidden">
      {/* Background Image with Parallax */}
      <motion.div
        style={{ y, scale }}
        className="absolute inset-0 w-full h-full"
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroData.backgroundImage})`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-farm-dark/70 via-farm-dark/50 to-farm-dark" />
      </motion.div>

      {/* Content */}
      <motion.div
        style={{ opacity }}
        className="relative h-full flex items-center justify-center px-6"
      >
        <div className="max-w-6xl mx-auto text-center">
          {/* Animated Headline with Line-by-Line Reveal */}
          <motion.div
            variants={titleVariants}
            initial="hidden"
            animate="visible"
            className="space-y-4"
          >
            <motion.h1
              variants={lineVariants}
              className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-farm-cream leading-tight"
            >
              Where Excellence in Dairy
            </motion.h1>
            <motion.h1
              variants={lineVariants}
              className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold leading-tight"
            >
              <span className="text-farm-gold">Meets the Legacy</span>
            </motion.h1>
            <motion.h1
              variants={lineVariants}
              className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-farm-cream leading-tight"
            >
              of Champions
            </motion.h1>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="mt-8 text-xl md:text-2xl text-farm-cream/80 max-w-3xl mx-auto"
          >
            {heroData.subheading}
          </motion.p>

          {/* CTA Buttons */}
          {/* <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(200, 165, 75, 0.5)' }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-farm-gold text-farm-dark rounded-lg font-semibold text-lg flex items-center gap-2 shadow-xl hover:bg-farm-cream transition-colors duration-300"
            >
              Explore Dairy
              <ArrowRight size={20} />
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-transparent border-2 border-farm-cream text-farm-cream rounded-lg font-semibold text-lg hover:bg-farm-cream hover:text-farm-dark transition-all duration-300 flex items-center gap-2"
            >
              Discover Stud Farm
              <ArrowRight size={20} />
            </motion.button>
          </motion.div> */}

          {/* Scroll Indicator */}
          {/* <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.8 }}
            className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
          >
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
              className="w-6 h-10 border-2 border-farm-gold rounded-full flex items-start justify-center p-2"
            >
              <motion.div
                animate={{ y: [0, 12, 0] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
                className="w-1.5 h-1.5 bg-farm-gold rounded-full"
              />
            </motion.div>
          </motion.div> */}
        </div>
      </motion.div>
    </div>
  );
};